import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid } from "@mui/material";
import { DevicePreview, Form } from "@shared/components";

export function WhiteLabelStep() {
  const translate = useTranslate();

  return (
    <Grid container spacing={5}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="page_name"
          label={translate("flux.fields.page_name")}
          instructions={translate("flux.instructions.page_name")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.SinglePhotoPicker
          name="logo"
          label={translate("flux.fields.logo")}
          size={150}
          shape="square"
        />
      </Grid>

      <Grid container spacing={3} size={{ xs: 12 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Form.ColorPickerInput
            name="primary_color"
            label={translate("flux.fields.primary_color")}
            defaultValue="#db3657"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Form.ColorPickerInput
            name="background_color"
            label={translate("flux.fields.background_color")}
            defaultValue="#FAFAFA"
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Form.ColorPickerInput
            name="secondary_color"
            label={translate("flux.fields.secondary_color")}
            defaultValue="#FAFAFA"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Form.ColorPickerInput
            name="menu_color"
            label={translate("flux.fields.menu_color")}
            defaultValue="#000000"
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Form.ColorPickerInput
            name="primary_font_color"
            label={translate("flux.fields.primary_font_color")}
            defaultValue="#000000"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Form.ColorPickerInput
            name="secondary_font_color"
            label={translate("flux.fields.secondary_font_color")}
            defaultValue="#000000"
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Form.ColorPickerInput
            name="menu_font_color"
            label={translate("flux.fields.menu_font_color")}
            defaultValue="#FFFFFF"
          />
        </Grid>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="home_text"
          label={`${translate("flux.fields.home_text")}*`}
          multiline
          rows={4}
          helperText={translate("flux.helpers.home_text")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <DevicePreview />
      </Grid>
    </Grid>
  );
}
